import type { FontFaceSpec } from '../../types';
import woff2 from '../src/PPMori-RegularItalicNew.woff2';
import woff from '../src/PPMori-RegularItalicNew.woff';

export const ppMoriRegularItalic: FontFaceSpec = {
  weight: 400,
  style: 'italic',
  src: [
    { file: woff2, format: 'woff2' },
    { file: woff, format: 'woff' },
  ],
};
